import _get from 'lodash/get'
import _isBoolean from 'lodash/isBoolean'
import { renew } from 'services/auth'
import { getEmailAvailability } from 'services/user'
import { setAuthPersistentData } from 'services/auth/actions'
import {
  approveRemoteLoginCode,
  consumeRemoteLoginCode,
  requestMagicLink,
  approvePrivateLoginCode,
  MAGIC_LINK_EMAIL_MODE_LINK_ONLY,
} from './index'

export const SET_REMOTE_LOGIN_CODE = 'SET_REMOTE_LOGIN_CODE'
export const SET_REMOTE_LOGIN_CODE_PROCESSING = 'SET_REMOTE_LOGIN_CODE_PROCESSING'
export const SET_REMOTE_LOGIN_CODE_DATA = 'SET_REMOTE_LOGIN_CODE_DATA'

export function getRemoteLoginCodeApproval ({ auth, remoteLoginCode }) {
  return async function getRemoteLoginCodeApprovalThunk (dispatch) {
    dispatch(setRemoteLoginCodeProcessing(true))
    const data = await approveRemoteLoginCode({ auth, remoteLoginCode })
    dispatch(setRemoteLoginCodeData(data))
    return data
  }
}

export function setRemoteLoginCode (value) {
  return {
    type: SET_REMOTE_LOGIN_CODE,
    payload: value,
  }
}

export function setRemoteLoginCodeProcessing (value) {
  return {
    type: SET_REMOTE_LOGIN_CODE_PROCESSING,
    payload: value,
  }
}

export function setRemoteLoginCodeData (data, processing = false) {
  return {
    type: SET_REMOTE_LOGIN_CODE_DATA,
    payload: { data, processing },
  }
}

async function renewAuthFromRemoteLoginCode (dispatch, remoteLoginCode) {
  const { jwt } = await consumeRemoteLoginCode({ remoteLoginCode })
  // Renew auth data with a jwt obtained from remote login code response
  const data = await renew({ auth: { jwt }, logoutAllDevices: false })
  const auth = _get(data, 'auth')
  const success = _get(auth, 'success', false)
  if (success) {
    dispatch(setAuthPersistentData(auth))
  }
  return { success: !!success, auth }
}

export function doConsumeRemoteLoginCode ({ remoteLoginCode }) {
  return async function doConsumeRemoteLoginCodeThunk (dispatch) {
    try {
      return await renewAuthFromRemoteLoginCode(dispatch, remoteLoginCode)
    } catch (e) {
      return { success: false }
    }
  }
}

export function doRequestMagicLink ({
  email,
  language,
  emailMode = MAGIC_LINK_EMAIL_MODE_LINK_ONLY,
  consumeOnClick = true,
  redirect,
}) {
  return async function doRequestMagicLinkThunk (dispatch) {
    try {
      dispatch(setRemoteLoginCodeProcessing(true))
      const { available } = await getEmailAvailability({ email })
      if (!_isBoolean(available) || available === true) {
        throw new Error('emailNotExists')
      }
      const { remoteLoginCode, expiresAt } = await requestMagicLink({
        email,
        language,
        emailMode,
        consumeOnClick,
        redirect,
      })
      return { success: true, remoteLoginCode, expiresAt }
    } catch (e) {
      return { success: false, message: e.message }
    } finally {
      dispatch(setRemoteLoginCodeProcessing(false))
    }
  }
}

export function doApprovePrivateLoginCode ({
  privateCode,
  consumeApprovedCode = false,
}) {
  return async function doApprovePrivateLoginCodeThunk (dispatch) {
    try {
      dispatch(setRemoteLoginCodeProcessing(true))
      const { remoteLoginCode } = await approvePrivateLoginCode({ privateCode })
      if (remoteLoginCode) {
        if (consumeApprovedCode) {
          return await renewAuthFromRemoteLoginCode(dispatch, remoteLoginCode)
        }
        return { success: true, remoteLoginCode }
      }
      return { success: false }
    } catch (e) {
      return { success: false, message: e.message }
    } finally {
      dispatch(setRemoteLoginCodeProcessing(false))
    }
  }
}
